export const STORE = "BANKS";
export const SET_BANKS = "SET_BANKS";
export const GET_BANKS = "GET_BANKS";
export const FETCH_BANKS = "FETCH_BANKS";
